<template>
  <section v-if="airline && lang && lang.taxi">
    <div class="spinner-action" :class="{ 'spinner-active': spinner_active }">
      <div class="spinner-border text-dark icon-spinner" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div v-if="!listPaxIdShareTaxi.length">
      <div style="margin: 14pt 0">{{ lang['taxi'].SFS_LANG_TAXI_VOUCHER_ALREADY_PROVIDED }}</div>
    </div>
    <div v-else :class="{ 'taxi-info': step_booking != 1 && step_booking != 2 }">
      <div class="my-4">
        <div v-if="step_booking == 1">
          <!-- Title -->
          <div v-if="!checkShowCard" class="reserve-container">
            <h2 class="title-choose-photo">
              <u>{{ lang['taxi'].SFS_LANG_BOOK_TAXI_1 }}</u>
            </h2>
          </div>
          <div class="taxi-info">
            <div v-if="listDataBooking.length" id="walking-map">
              <div v-if="isWalkingDistance && !isConfirmWalking" class="card walking-inform">
                <div class="card-body">
                  <p class="mb-3">
                    {{ lang.taxi['SFS_LANG_BOOK_TAXI_2'] }} <span>{{ pax.first_name }} {{ pax.last_name }}</span>
                  </p>
                  <p class="mb-3">{{ lang.taxi['SFS_LANG_BOOK_TAXI_3'] }}</p>
                  <p>{{ lang.taxi['SFS_LANG_BOOK_TAXI_4'] }}</p>
                </div>
                <div class="map">
                  <b v-if="isShowMap" class="py-3 ml-2 d-block cursor show-on-map" @click="showMap(false)"
                    >{{ lang.taxi['SFS_LANG_BOOK_TAXI_8'] }}
                    <i class="fas fa-chevron-down ml-1"></i>
                  </b>
                  <b v-else class="py-3 ml-2 d-block cursor show-on-map" @click="showMap(true)"
                    >{{ lang.taxi['SFS_LANG_BOOK_TAXI_7'] }}
                    <i class="fas fa-chevron-right ml-1"></i>
                  </b>
                  <div>
                    <WalkingMap
                      :origin="locationInMap.origin"
                      :is-show-map="isShowMap"
                      :destination="locationInMap.destination"
                      @checkWalkingDistance="checkWalkingDistance"
                    />
                  </div>
                </div>
              </div>
              <div v-else-if="!checkShowCard">
                <!-- Address Info -->
                <div class="address-info">
                  <h2 class="title-choose-photo">
                    <u> {{ lang.taxi['SFS_LANG_ROW_2'] }}</u>
                  </h2>
                  <AddressInfo
                    :address-title="addressTitle"
                    :origin="dataLocationTaxi.origin"
                    :destination="dataLocationTaxi.destination"
                    :init-show-map="false"
                    @updateLocation="updateLocation"
                    @getPriceByDistance="getPriceByDistance"
                  ></AddressInfo>
                </div>
                <!-- Pick up time -->
                <div class="pick-up-time">
                  <h2 class="title-choose-photo">
                    <u>{{ lang.taxi['SFS_LANG_BOOK_TAXI_9'] }}</u>
                  </h2>
                  <PickUpTime
                    :pick-up-title="pickUpTitle"
                    @changePreferedTimePickUp="handlePickTime"
                    @changePickUpState="changePickUpState"
                  ></PickUpTime>
                </div>
              </div>
              <div v-if="!checkShowCard" class="d-flex justify-content-center">
                <div
                  v-if="isWalkingDistance && !isConfirmWalking"
                  class="book-taxi ws-btn hd-normal-btn-background-color hd-normal-btn-color"
                  @click="confirmWalking()"
                >
                  <span style="color: white">{{ lang.taxi['SFS_LANG_BOOK_TAXI_6'] }}</span>
                </div>
                <div v-else class="book-taxi ws-btn hd-normal-btn-background-color hd-normal-btn-color" @click="bookTaxi()">
                  <span style="color: white">{{ lang.taxi['SFS_LANG_BOOK_TAXI_12'] }}</span>
                </div>
              </div>
            </div>
          </div>
          <div v-if="checkShowCard">
            <div class="ws-textbox mt-4">
              {{ lang.taxi['SFS_LANG_BOOK_TAXI_5'] }}
              <span class="font-weight-bold">
                {{ taxi_way == 0 ? paxsHotel.name : airline.airport_name }}
              </span>
            </div>
            <div class="mt-4">
              <HotelCard
                v-if="paxsHotel"
                :hotel-info="paxsHotel"
                :is-show-g-g-map="true"
                :way-taxi="taxi_way"
                :origin="locationInMap.origin"
                :destination="locationInMap.destination"
                :time-pickup="timePickup"
                :list-data-booking="listDataBooking"
                :pick-up-title="pickUpTitle"
                @changePickUpState="changePickUpState"
                @confirmPickUpTime="handlePickTime"
              />
            </div>
            <div class="my-4 text-center">
              <button class="book-taxi ws-btn hd-normal-btn-background-color hd-normal-btn-color" @click="bookTaxi()">
                {{ lang.taxi['SFS_LANG_BOOK_TAXI_12'] }}
              </button>
            </div>
          </div>
        </div>
        <div v-if="step_booking == 2">
          <div v-for="(karhooTaxi, index) in listBookingKarhooTaxi" :key="index">
            <div v-if="karhooTaxi.taxi_way == taxi_way" class="block-booking taxi-info">
              <h4 class="taxi-info-title">
                {{ lang.taxi['SFS_LANG_BOOK_TAXI_17'] }}
              </h4>
              <div>
                <span class="font-weight-bold">{{ lang.taxi['SFS_LANG_BOOK_TAXI_18'] }}</span>
                <span>{{
                  karhooTaxi.local_date_scheduled
                    ? moment(karhooTaxi.local_date_scheduled).format('HH:mm')
                    : lang.taxi['SFS_LANG_BOOK_TAXI_10']
                }}</span>
              </div>
              <div>
                <span class="font-weight-bold">{{ lang.taxi['SFS_LANG_BOOK_TAXI_19'] }}</span>
                <span>{{ karhooTaxi.origin_address }}</span>
              </div>
              <div>
                <span class="font-weight-bold">{{ lang.taxi['SFS_LANG_BOOK_TAXI_20'] }}</span>
                <span>{{ karhooTaxi.driver_name ? karhooTaxi.driver_name : 'Updating' }}</span>
              </div>
              <div>
                <span class="font-weight-bold">{{ lang.taxi['SFS_LANG_BOOK_TAXI_21'] }}</span>
                <span>{{ checkDriverVehicle(karhooTaxi.driver_vehicle) ? karhooTaxi.driver_vehicle : 'Updating' }}</span>
              </div>
              <div>
                <span class="font-weight-bold">{{ lang.taxi['SFS_LANG_BOOK_TAXI_22'] }}</span>
                <span>{{ checkDriverVehicle(karhooTaxi.driver_vehicle) ? karhooTaxi.vehicle_license_plate : 'Updating' }}</span>
              </div>
              <div>
                <span class="font-weight-bold">{{ lang.taxi['SFS_LANG_BOOK_TAXI_23'] }}</span>
                <span>{{ karhooTaxi.booking_id }}</span>
              </div>
              <div class="pt-3">
                <hr />
                <div
                  v-if="!showMapBeforeBooking"
                  class="text-center cursor-pointer opacity--05"
                  @click="
                    showMapBeforeBooking = true
                    showMap(true)
                  "
                >
                  {{ lang.taxi['SFS_LANG_BOOK_TAXI_24'] }}
                </div>
                <div>
                  <WalkingMap
                    :origin="locationInMap.origin"
                    :is-show-map="isShowMap"
                    :destination="locationInMap.destination"
                    @checkWalkingDistance="checkWalkingDistance"
                  />
                </div>
              </div>
            </div>
            <div v-if="karhooTaxi.taxi_way == taxi_way" class="my-4 text-center d-flex align-items-center justify-content-around">
              <button
                v-if="karhooTaxi.status !== KARHOO_COMPLETED_STATUS"
                class="ws-btn btn-confirm hd-normal-btn-background-color hd-normal-btn-color opacity--08"
                :class="{ 'mr-3': karhooTaxi.driver_vehicle && karhooTaxi.driver_phone }"
                @click="cancelTaxi(karhooTaxi.booking_id, 0)"
              >
                {{ lang.taxi['SFS_LANG_BOOK_TAXI_25'] }}
              </button>
              <button
                v-if="karhooTaxi.driver_vehicle && karhooTaxi.driver_phone"
                class="ws-btn btn-confirm hd-normal-btn-background-color hd-normal-btn-color"
                :class="{ 'ml-3': karhooTaxi.status !== KARHOO_COMPLETED_STATUS }"
              >
                <a :href="`tel:${karhooTaxi.driver_phone}`" class="text-call-driver">{{ lang.taxi['SFS_LANG_BOOK_TAXI_26'] }}</a>
              </button>
            </div>
          </div>
        </div>
        <div v-if="airline.params && step_booking == 3">
          <div class="block-booking">
            <div class="col-2 pl-0 mb-2">
              <i class="fab fa-mixcloud fa-2x"></i>
            </div>
            <div class="col-10 pl-0">
              <p style="white-space: pre-line" v-html="lang.taxi['SFS_LANG_BOOK_TAXI_27']"></p>
            </div>
          </div>
          <div class="row py-3">
            <div class="col-6 offset-3 text-center" @click="step_booking = 1">
              <p class="ws-btn bg-btn-taxi btn-select">{{ lang.taxi['SFS_LANG_BOOK_TAXI_28'] }}</p>
              <p class="small">
                {{ taxiService.params.times_attempts_to_connect_karhoo || 0 }}/{{ airline.times_attempts_to_connect_karhoo }}
                {{ airline.times_attempts_to_connect_karhoo > 1 ? 'times' : 'time' }}
              </p>
            </div>
          </div>
        </div>
        <div v-if="step_booking == 4">
          <div class="block-booking">
            <div class="mb-2">{{ lang.taxi['SFS_LANG_ROW_2'] }} {{ pax.title }}. {{ pax.full_name }},</div>
            <div>
              <p style="white-space: pre-line" v-html="lang.taxi['SFS_LANG_BOOK_TAXI_29']"></p>
            </div>
          </div>
          <div class="bg-btn-taxi btn-select w-50">
            <router-link :to="{ name: 'HotelList', query: { secret: secret } }">
              <span style="color: white">{{ lang.taxi['SFS_LANG_BOOK_TAXI_30'] }}</span>
            </router-link>
          </div>
        </div>
        <div v-if="step_booking == 5">
          <div class="block-booking">
            <div class="mb-2">{{ lang.taxi['SFS_LANG_ROW_2'] }} {{ pax.title }}. {{ pax.full_name }},</div>
            <div>
              <p style="white-space: pre-line" v-html="lang.taxi['SFS_LANG_ROW_31']"></p>
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <button class="book-taxi ws-btn hd-normal-btn-background-color hd-normal-btn-color">
              <router-link :to="{ name: 'TaxiService', query: { secret: secret } }">
                <span style="color: white">{{ lang.taxi['SFS_LANG_BOOK_TAXI_6'] }}</span>
              </router-link>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <b-modal
      id="modal-popup-waiting"
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
      class="border-0"
      :title="'Call taxi company'"
      @shown="progressBar"
    >
      <div class="d-block">
        <p>
          <span v-html="replaceStr(lang.taxi['SFS_LANG_BOOK_TAXI_13'], ['<feet_name>'], [fleetInfo.name])"></span>
        </p>
        <p>{{ lang.taxi['SFS_LANG_BOOK_TAXI_14'] }}</p>
        <div id="myProgress" class="ws-progress-bar-container ws-progress-bar-container--desktop my-3">
          <div id="myBar" class="ws-progress-bar" :style="{ width: `${progressBarWidth}%` }"></div>
        </div>
        <div class="row">
          <div class="col-6" :class="{ 'col-12 text-center': show_button_cancel_fleet && !show_button_call_taxi_company }">
            <div
              v-if="show_button_cancel_fleet"
              class="btn-confirm ws-btn hd-normal-btn-background-color hd-normal-btn-color"
              @click="cancelTaxi(fleetInfo.booking_id, 1)"
            >
              <span class="text-line-clamp-1">{{ lang.taxi['SFS_LANG_BOOK_TAXI_15'] }}</span>
            </div>
          </div>
          <div class="col-6" :class="{ 'col-12 text-center': show_button_call_taxi_company && !show_button_cancel_fleet }">
            <div
              v-if="show_button_call_taxi_company"
              class="btn-confirm ws-btn hd-normal-btn-background-color hd-normal-btn-color"
            >
              <a :href="`tel:${fleetInfo.phone}`" class="text-white text-call-driver text-line-clamp-1">
                {{ lang.taxi['SFS_LANG_BOOK_TAXI_16'] }}
              </a>
            </div>
          </div>
        </div>
      </div>
      <div slot="modal-backdrop" class="modal-backdrop modal-backdrop__waiting"></div>
    </b-modal>
    <b-alert
      v-model="showAlertTop"
      class="position-fixed fixed-top m-0 rounded-0"
      style="z-index: 2000; border-radius: 1rem !important; border: 1px solid #ffa5a5; color: #444"
      variant="danger"
      dismissible
    >
      <div v-for="(error, index) in messagesError" :key="index">
        <div>{{ error }}</div>
      </div>
    </b-alert>
  </section>
</template>

<script>
import '@/assets/scss/modules/TaxiInfo.scss'
import { mapGetters } from 'vuex'
import Vue from 'vue'
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'
import moment from 'moment'
Vue.use(VueTimepicker)
import 'vue-tel-input/dist/vue-tel-input.css'
import * as _ from 'lodash'
import { replaceStr } from '@/utils/helper'

import AddressInfo from '@/components/AddressInfo/index'
import PickUpTime from '@/components/PickUpTime/index'
import WalkingMap from './WalkingMap'
import HotelCard from './HotelCard'

const ONE_AIRPORT_HOTEL = 1
const TWO_AIRPORT_HOTEL = 2
const ONE_HOTEL_AIRPORT = 3
const ONE_AIRPORT_ADDRESS = 4

const AIRPORT_HOTEL = 1
const HOTEL_AIRPORT = 2
const AIRPORT_ADDRESS = 3
const ADDRESS_AIRPORT = 4

const STATUS_CODE_CANCEL_SUCCESS = ['K4010']
const PROGRESSING_COUNTER = 120 // The maximum number of request get Karhoo quote details
const KARHOO_COMPLETED_STATUS = 'COMPLETED'

export default {
  name: 'KarhooTaxi',
  components: {
    AddressInfo,
    PickUpTime,
    WalkingMap,
    HotelCard
  },
  props: {
    secret: {
      type: String,
      default: ''
    },
    indexBooking: {
      type: Number,
      default: 0
    },
    overnightStation: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data() {
    return {
      KARHOO_COMPLETED_STATUS,
      //default is Amsterdam
      timeNow: new Date(),
      actionFetchData: {
        pax: false,
        voucher_hotel: false,
        voucher_taxi: false,
        group_pax: false,
        service: false
      },
      curPaxInfo: null,
      curPaxId: null,
      taxiService: {},
      listPaxShareTaxi: [],
      listPaxIdShareTaxi: [],
      phone_booking: null,
      center: { lat: 52.370216, lng: 4.895168 },
      karhoo_taxi_booking: {},
      listBookingKarhooTaxi: [],
      karhooTaxiDetail: {},
      waitingGetDetail: false,
      step_booking: 0,
      have_hotel: 1,
      timePickup: {
        HH: '00',
        mm: '00'
      },
      no_time_pickup: true,
      next_day: false,
      spinner_active: false,
      progressing_counter: PROGRESSING_COUNTER,
      isBooking: false,
      is_two_way: false,
      taxi_way: 0, // 0 : airport to hotel, 1: hotel to airport
      option_taxi: 0,
      isFirstTripCompleted: false,
      isCancel: false,
      isDisabledTaxiWayAirport: false,
      isDisabledTaxiWayHotel: false,
      fleetInfo: {
        name: '',
        phone: ''
      },
      show_button_call_taxi_company: false,
      show_button_cancel_fleet: false,
      showBackground: false,
      isWalkingDistance: false,
      isShowMap: false,
      listDataBooking: [],
      isConfirmWalking: false,
      distance: 0,
      showMapBeforeBooking: false,
      showAlertTop: false,
      messagesError: [],
      progressBarWidth: 10,
      setIntervalId: null,
      addressTitle: {},
      pickUpTitle: {}
    }
  },
  computed: {
    ...mapGetters({
      Services: 'Home/Services',
      PaxsGroup: 'Home/PaxsGroup',
      Voucher: 'Taxi/Voucher',
      voucherHotel: 'SelectRoom/PaxsHotel',
      paxsHotel: 'SelectRoom/PaxsHotel'
    }),
    dataLocationTaxi() {
      let dataBooking = this.listDataBooking[this.taxi_way]
      if (_.isEmpty(dataBooking) || _.isUndefined(dataBooking)) {
        dataBooking = _.find(this.listDataBooking, { way: parseInt(this.taxi_way) })
      }
      return dataBooking
    },
    locationInMap() {
      return {
        origin: {
          lat: this.dataLocationTaxi ? parseFloat(this.dataLocationTaxi.origin.lat) : '',
          lng: this.dataLocationTaxi ? parseFloat(this.dataLocationTaxi.origin.lng) : ''
        },
        destination: {
          lat: this.dataLocationTaxi ? parseFloat(this.dataLocationTaxi.destination.lat) : '',
          lng: this.dataLocationTaxi ? parseFloat(this.dataLocationTaxi.destination.lng) : ''
        }
      }
    },
    checkShowCard() {
      let self = this
      if (!self.paxsHotel || !self.listDataBooking.length) return false
      if (self.listDataBooking.length > 1) return true
      let voucher = self.listDataBooking.length == 1 ? self.listDataBooking[0] : ''
      if (!voucher) return false
      let hotelGeoLat = parseFloat(self.paxsHotel.geo_lat)
      let hotelGeoLng = parseFloat(self.paxsHotel.geo_long)
      let checkOriginHotel =
        parseFloat(voucher.origin.lat) == hotelGeoLat && parseFloat(voucher.origin.lng) == hotelGeoLng ? true : false
      let checkDestinationHotel =
        parseFloat(voucher.destination.lat) == hotelGeoLat && parseFloat(voucher.destination.lng) == hotelGeoLng ? true : false
      return checkOriginHotel || checkDestinationHotel
    }
  },
  watch: {
    showAlertTop() {
      if (this.showAlertTop) {
        setTimeout(() => {
          this.showAlertTop = false
        }, 5000)
      }
    }
  },
  created() {
    this.setTimePickUp()
  },
  beforeUnmount() {
    clearInterval(this.setIntervalId)
  },
  mounted() {
    this.initData()
    this.getLocation()
  },
  methods: {
    onRunProgressBar() {
      const self = this
      this.setIntervalId = setInterval(function () {
        if (self.progressBarWidth >= 100) {
          self.progressBarWidth = 0
        }
        self.progressBarWidth = self.progressBarWidth + 1
      }, 50)
    },
    setTimePickUp() {
      let d = new Date(+new Date() + 60000 * 30)
      let minutes =
        d.getMinutes() / 5 === 0
          ? d.getMinutes()
          : d.getMinutes() % 10 > 5
          ? d.getMinutes() - (d.getMinutes() % 10) + 10
          : d.getMinutes() - (d.getMinutes() % 10)
      this.$set(this.timePickup, 'HH', String(d.getHours()).length === 1 ? `0${d.getHours()}` : d.getHours().toString())
      this.$set(this.timePickup, 'mm', String(minutes).length === 1 ? `0${minutes}` : minutes.toString())
    },
    replaceStr,
    bookTaxi: function (quote_id = 0) {
      this.messagesError = []
      this.showAlertTop = false
      let self = this

      self.phone_booking = self.phone_booking || self.pax.phone_number
      if (_.isEmpty(self.Voucher)) {
        this.$swal(self.lang.taxi['SFS_LANG_BOOK_TAXI_32'])
        return
      }
      let momentDate = moment()
      let hourSet = this.timePickup.HH
      let minuteSet = this.timePickup.mm
      momentDate.set({ hour: hourSet, minute: minuteSet })
      let timeFormat = momentDate.format('YYYY-MM-DDTHH:mm')
      // compare pick-up time with now
      // if (new Date(timeFormat).getTime() < new Date().getTime() && !this.next_day) {
      //   this.messagesError.push('The selected time must be greater than the current time')
      //   this.showAlertTop = true
      //   return
      // }
      let m = moment()
      let current = m.format('YYYY-MM-DDTHH:mm')
      let way = this.option_taxi == 3 ? 1 : parseInt(self.taxi_way)
      let origin = {
        display_address: self.dataLocationTaxi.origin.display_address,
        latitude: self.dataLocationTaxi.origin.lat,
        longitude: self.dataLocationTaxi.origin.lng
      }
      let destination = {
        display_address: self.dataLocationTaxi.destination.display_address,
        latitude: self.dataLocationTaxi.destination.lat,
        longitude: self.dataLocationTaxi.destination.lng
      }
      let dataSend = {
        location: {
          origin: origin,
          destination: destination,
          local_time_of_pickup: self.no_time_pickup ? null : self.formatTimePickup(self.timePickup),
          current_local_time: current
        },
        passengers: {
          number_passengers: self.listPaxIdShareTaxi.length,
          first_name: self.curPaxInfo.first_name,
          last_name: self.curPaxInfo.last_name,
          pax_lead: self.pax.id,
          phone_number: self.phone_booking || self.pax.phone_number,
          group_pax_ids: self.listPaxIdShareTaxi
        },
        airline_id: self.airline.airline_id,
        taxi_way: way,
        quote_id: quote_id
      }
      self.spinner_active = true
      self.isBooking = true
      self.$store.dispatch('KarhooTaxi/karhooBook', dataSend).then((response) => {
        if (response.success) {
          self.karhoo_taxi_booking = response.data
          self.isCancel = false
          self.getDetailBooking(self.karhoo_taxi_booking.booking_id, false)
        } else {
          if (response.data && response.data.status === 'PROGRESSING' && self.progressing_counter > 0) {
            // Retry to get a quote
            setTimeout(function () {
              self.bookTaxi(response.data.quote_id)
              self.progressing_counter--
            }, 500) // 500: the time retry get Karhoo quote detail
          } else {
            if (response.lookup_phone_number === false) {
              self.step_booking = 1
            } else {
              self.step_booking = 3
            }
            self.spinner_active = false
            self.saveAttempts()
            self.progressing_counter = PROGRESSING_COUNTER
          }
        }
      })
    },
    saveAttempts: function () {
      let dataSend = {
        passenger_service_id: this.taxiService.id
      }

      this.$store.dispatch('KarhooTaxi/saveAttempts', dataSend).then((response) => {
        if (response.success) {
          let attempt = response.data.times_attempts_to_connect_karhoo
          this.taxiService.params.times_attempts_to_connect_karhoo = attempt
          if (parseInt(attempt) === parseInt(this.airline.times_attempts_to_connect_karhoo)) {
            this.$emit('updateState')
          }
        }
      })
    },
    confirmWalking: function () {
      this.isConfirmWalking = true
    },
    showMap: function (isShow) {
      this.isShowMap = isShow
    },
    getDetailBooking: function (booking_id, isReload) {
      let self = this
      self.isBooking = false
      if (self.isCancel) {
        return
      }
      let dataSend = {
        booking_id: booking_id,
        airline_id: self.airline.airline_id
      }
      self.$store.dispatch('KarhooTaxi/getDetail', dataSend).then((response) => {
        self.spinner_active = false
        if (response.success) {
          let data = response.data
          self.fleetInfo = {
            name: data.fleet_name,
            phone: data.fleet_phone,
            booking_id: data.booking_id
          }
          data.link_follow = self.airline.params.karhoo.portal_url + '/follow/' + data.follow_code
          self.step_booking = 2
          if (self.listBookingKarhooTaxi.length === 0 || (self.listBookingKarhooTaxi.length === 1 && self.isFirstTripCompleted)) {
            self.listBookingKarhooTaxi.push(data)
          }
          self.isFirstTripCompleted = data.status === KARHOO_COMPLETED_STATUS
          if (!_.isEmpty(self.listBookingKarhooTaxi)) {
            self.listBookingKarhooTaxi = _.map(self.listBookingKarhooTaxi, function (booking) {
              if (booking.booking_id === data.booking_id) {
                booking = data
              }
              return booking
            })
          }
          if (data.driver_vehicle) {
            clearInterval(this.setIntervalId)
            this.$bvModal.hide('modal-popup-waiting')
          }
          if (!data.driver_vehicle || data.status !== KARHOO_COMPLETED_STATUS) {
            if (!isReload) {
              this.onRunProgressBar()
              this.$bvModal.show('modal-popup-waiting')
            }
            // Retry to get Driver detail
            setTimeout(function () {
              self.getDetailBooking(booking_id, true)
            }, 2000) // 2000: the time retry get Driver detail
          } else {
            self.$swal.close()
          }
        }
      })
    },
    checkDriverVehicle: function (driver_vehicle) {
      if (!driver_vehicle) return false
      let driverVehicle = driver_vehicle.trim()
      return !!driverVehicle
    },
    updateLocation(data) {},
    getPriceByDistance(data) {},

    changePickUpState(state) {
      this.next_day = state.next_day
      this.no_time_pickup = state.no_time_pickup
    },
    getDetailPassengerBooking: function () {
      let self = this
      let dataSend = {
        passenger_id: self.curPaxId,
        airline_id: self.airline.airline_id
      }
      self.$store.dispatch('KarhooTaxi/getPassengerDetail', dataSend).then((response) => {
        if (response.success) {
          self.listBookingKarhooTaxi = response.data
          _.forEach(self.listBookingKarhooTaxi, function (item) {
            item.link_follow = self.airline.params.karhoo.portal_url + '/follow/' + item.follow_code
            if (!item.driver_vehicle) {
              self.$swal(self.lang.taxi['SFS_LANG_BOOK_TAXI_31'])
              self.getDetailBooking(item.booking_id, true)
            }
            if (item.status !== KARHOO_COMPLETED_STATUS) {
              self.getDetailBooking(item.booking_id, true)
            }
          })
          let firstTrip = self.listBookingKarhooTaxi[0]
          let currentTrip = _.find(self.listBookingKarhooTaxi, { taxi_way: self.taxi_way })

          self.isFirstTripCompleted = firstTrip.status == KARHOO_COMPLETED_STATUS

          if (!self.isFirstTripCompleted) {
            self.step_booking = 2
          } else {
            if (self.taxi_way == firstTrip.taxi_way || !_.isUndefined(currentTrip) || self.listBookingKarhooTaxi.length > 1) {
              self.step_booking = 2
            } else {
              self.step_booking = 1
            }
          }
        } else {
          self.step_booking = 1
        }
      })
    },

    cancelTaxi: function (booking_id, is_abort) {
      let self = this
      self.isCancel = true
      let dataSend = {
        booking_id: booking_id,
        airline_id: self.airline.airline_id,
        is_abort: is_abort
      }
      this.onRunProgressBar()
      self.$store.dispatch('KarhooTaxi/cancelTaxi', dataSend).then((response) => {
        if (response.success) {
          this.$emit('updateState')
          this.$bvModal.hide('modal-popup-waiting')
        } else {
          self.isCancel = false
          let confirm = self.$swal(response.message.wsData.message)
          confirm.then((result) => {
            if (result.value && STATUS_CODE_CANCEL_SUCCESS.indexOf(response.message.wsData.code) >= 0) {
              this.$emit('updateState')
            }
          })
        }
      })
    },
    formatTimePickup: function (time) {
      if (!time) {
        return null
      }
      let m = moment()
      if (this.next_day) {
        m.add(1, 'days')
      }
      let hourSet = time.HH
      let minuteSet = time.mm
      m.set({ hour: hourSet, minute: minuteSet })
      let timeFormat = m.format('YYYY-MM-DDTHH:mm')
      return timeFormat
    },
    initData: function () {
      this.curPaxId = this.pax.id || this.pax.curPaxID
      this.taxi_way = this.indexBooking
      // Get current passenger info
      this.curPaxInfo = this.pax
      if (this.PaxsGroup.length > 1) {
        this.curPaxInfo = _.find(this.PaxsGroup, { passenger_id: parseInt(this.pax.curPaxID) })
      }
      this.listPaxIdShareTaxi = [this.curPaxId]
      this.taxiService = _.find(this.Services, function (service) {
        return service.service_id == 4
      })

      // check matrix_share_taxi is available
      let matrixShareTaxi =
        this.taxiService.params && this.taxiService.params.matrix_share_taxi ? [...this.taxiService.params.matrix_share_taxi] : []
      let paxPerTaxi = this.airline.params && this.airline.params.pax_per_taxi ? this.airline.params.pax_per_taxi : 3

      if (!matrixShareTaxi.length && this.PaxsGroup && this.airline.params.pax_per_taxi && this.PaxsGroup.length > paxPerTaxi) {
        this.$router.push({ path: '/home', query: { secret: this.secret } })
        return
      } else if (
        !matrixShareTaxi.length &&
        this.PaxsGroup &&
        this.airline.params.pax_per_taxi &&
        this.PaxsGroup.length < paxPerTaxi
      ) {
        let paxs = Object.values(this.PaxsGroup)
        let matrix = paxs.map(function (item) {
          return item.passenger_id
        })
        this.listPaxIdShareTaxi = [matrix]
      }

      if (
        !_.isEmpty(this.taxiService) &&
        !_.isEmpty(this.taxiService.params) &&
        !_.isEmpty(this.taxiService.params.matrix_share_taxi)
      ) {
        if (!_.isEmpty(matrixShareTaxi) && this.curPaxId) {
          _.each(matrixShareTaxi, (group) => {
            if (group.includes(this.curPaxId.toString()) || group.includes(this.curPaxId)) {
              this.listPaxIdShareTaxi = group
            }
          })
        }
      }
      if (!_.isEmpty(this.listPaxIdShareTaxi) && !_.isEmpty(this.PaxsGroup)) {
        _.each(this.listPaxIdShareTaxi, (paxId) => {
          this.listPaxShareTaxi.push(_.find(this.PaxsGroup, { passenger_id: parseInt(paxId) }))
        })
        if (!_.isEmpty(this.listPaxShareTaxi)) {
          let curPax = _.find(this.listPaxShareTaxi, { passenger_id: parseInt(this.curPaxId) })
          this.phone_booking = curPax.phone_number
          if (!this.phone_booking) {
            _.each(this.listPaxShareTaxi, (pax) => {
              if (!_.isEmpty(pax) && pax.phone_number) {
                this.phone_booking = pax.phone_number
              }
            })
          }
        }
      }
      if (this.curPaxId && this.airline.airline_id) {
        this.getDetailPassengerBooking()
      }
      if (this.lang && this.lang['taxi']) {
        this.addressTitle = {
          FROM: this.lang['taxi'].SFS_LANG_ROW_12,
          DISTANCE: this.lang['taxi'].SFS_LANG_ROW_9,
          TO: this.lang['taxi'].SFS_LANG_ROW_13,
          SHOW_MAP: this.lang['taxi'].SFS_LANG_ROW_14,
          HIDE_MAP: this.lang['taxi'].SFS_LANG_ROW_15
        }
        this.pickUpTitle = {
          NO_TIME_PICKUP: this.lang['taxi'].SFS_LANG_BOOK_TAXI_10,
          NEXT_DAY: this.lang['taxi'].SFS_LANG_BOOK_TAXI_11
        }
      }
    },

    checkTaxiKarhooTrip() {
      let self = this
      let completeTripCount = 0
      if (self.taxiService && self.taxiService.taxi_booking_detail.length > 0) {
        _.each(self.taxiService.taxi_booking_detail, function (item) {
          if (item.karhoo && (item.karhoo.status === 'COMPLETED' || item.karhoo.status === 'FAILED')) {
            completeTripCount += 1
          }
        })
        return completeTripCount == self.taxiService.taxi_booking_detail.length
      }
      return false
    },

    getLocation: function () {
      let self = this
      let paxIds = _.map(self.listPaxIdShareTaxi, function (id) {
        return parseInt(id)
      })
      let voucher = _.find(self.Voucher, function (vou) {
        return _.indexOf(paxIds, parseInt(vou.passenger_id)) >= 0
      })
      if (!voucher.start_point || !voucher.end_point || !voucher.to_address || !voucher.from_andress) {
        return
      }
      self.is_two_way = voucher.way_option == 2
      self.option_taxi = voucher.option_taxi
      self.taxi_way = self.option_taxi == 3 ? 1 : self.taxi_way
      let start_point = JSON.parse(voucher.start_point)
      let end_point = JSON.parse(voucher.end_point)
      let origin = {
        lat: start_point.Lat,
        lng: start_point.Lon,
        display_address: voucher.from_andress,
        disabled: true
      }
      let destination = {
        lat: end_point.Lat,
        lng: end_point.Lon,
        display_address: voucher.to_address,
        disabled: true
      }
      self.listDataBooking = []
      self.listDataBooking = [
        {
          way: self.getWay(voucher.option_taxi, 0),
          type: 0,
          est_amount: voucher.est_amount,
          currency: voucher.currency,
          origin: origin,
          destination: destination
        }
      ]

      if (self.is_two_way) {
        self.listDataBooking.push({
          way: self.getWay(voucher.option_taxi, 1),
          type: 1,
          est_amount: voucher.est_amount,
          currency: voucher.currency,
          origin: destination,
          destination: origin
        })
      }
    },

    getWay(taxi_option, num_way) {
      let way = 0
      switch (taxi_option) {
        case ONE_AIRPORT_HOTEL:
          way = AIRPORT_HOTEL
          break
        case TWO_AIRPORT_HOTEL:
          if (num_way == 0) {
            way = AIRPORT_HOTEL
          } else {
            way = HOTEL_AIRPORT
          }
          break
        case ONE_HOTEL_AIRPORT:
          way = AIRPORT_HOTEL
          break
        case ONE_AIRPORT_ADDRESS:
          if (num_way == 0) {
            way = AIRPORT_ADDRESS
          } else {
            way = ADDRESS_AIRPORT
          }
          break
        default:
          break
      }

      return way
    },

    checkWalkingDistance(distance) {
      let voucher = this.Voucher[_.first(_.keys(this.Voucher))]
      let maximumWalkingDistance =
        this.airline.airport_config_distance || this.airline.params.airline_config_taxi.maximum_walking_distance || 300
      this.distance = voucher.distance || distance
      this.isWalkingDistance = this.distance * 1000 <= parseFloat(maximumWalkingDistance)
    },
    confirmLeave() {
      return window.confirm('Do you really want to leave? The booking is in progressing!')
    },
    confirmStayInBooking() {
      return this.isBooking && !this.confirmLeave()
    },
    beforeWindowUnload(e) {
      if (this.confirmStayInBooking()) {
        // Cancel the event
        e.preventDefault()
        // Chrome requires returnValue to be set
        e.returnValue = ''
      }
    },
    progressBar() {
      let self = this
      self.show_button_call_taxi_company = false
      self.show_button_cancel_fleet = false
      let i = 0
      let timer = 0
      if (i === 0) {
        i = 1
        let elem = document.getElementById('myBar')
        if (elem) {
          let width = 0
          let timerInterval = setInterval(function () {
            timer++
            if (timer === 20) {
              self.show_button_call_taxi_company = true
            }
            if (timer === 180) {
              self.show_button_cancel_fleet = true
              clearInterval(timerInterval)
            }
          }, 1000)

          let id = setInterval(this.frame(width, id, elem, i), 10)
        }
      }
    },
    frame(width, id, elem, i) {
      if (width >= 100) {
        clearInterval(id)
        i = 0
      } else {
        width += 0.05
        elem.style.width = width + '%'
      }
    },
    handlePickTime(value) {
      this.$set(this.timePickup, 'HH', value['HH'] || '00')
      this.$set(this.timePickup, 'mm', value['mm'] || '00')
    }
  }
}
</script>
<style lang="scss" scoped>
section {
  .reserve-container,
  .address-info,
  .pick-up-time {
    background-color: #fafafa;
    padding: 0.5rem 1rem;
    border-radius: 0.75rem;
    margin-bottom: 10px;
  }
  //
  .title-choose-photo {
    padding-bottom: 1rem;
    margin-bottom: 0;
    u {
      text-decoration: none;
      font-weight: 400;
      color: #474747;
      font-size: 20px;
    }
  }
  h1,
  h2,
  h3,
  h4,
  p,
  span {
    color: #474747;
  }
}
.font-weight-580 {
  font-weight: 580;
}
.opacity--08 {
  opacity: 0.8;
}
.opacity--05 {
  opacity: 0.5;
}
a.text-call-driver {
  font-size: inherit;
  color: white;
}
.cursor-pointer {
  cursor: pointer;
}
::v-deep .modal-content {
  border: 0;
  border-radius: 0.8rem;
}
.ws-progress-bar-container--desktop {
  max-width: 100% !important;
}
.text-line-clamp-1 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.btn-select {
  background-color: #56c3e0;
  color: #fff;
  font-weight: 400;
  padding-top: 6pt;
  padding-bottom: 6pt;
  border-radius: 20px;
  width: 40%;
  border: none;
}
.taxi-info {
  span {
    color: #474747;
  }
  .taxi-info-title {
    font-size: 20px;
    font-weight: 400;
    color: #474747;
  }
  hr {
    margin-bottom: 0;
  }
  .cursor-pointer {
    font-size: 12px;
    color: #979797;
  }
}
</style>
